var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59701 9.1783H11.597M9.09701 11.6783V6.6783M17.4303 9.1783C17.4303 13.7807 13.6994 17.5116 9.09701 17.5116C4.49463 17.5116 0.763672 13.7807 0.763672 9.1783C0.763672 4.57593 4.49463 0.844971 9.09701 0.844971C13.6994 0.844971 17.4303 4.57593 17.4303 9.1783Z",
    stroke: "#7AE582",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircleBlue);
export default __webpack_public_path__ + "static/media/plus-circle-blue.f02ae5c47dfa5fa18a934d09ef7a3c21.svg";
export { ForwardRef as ReactComponent };